import { InjectionToken } from "@angular/core";

export const CURRENT_LANGS_TOKEN = new InjectionToken<string[]>('currentLangs', {
  providedIn: 'root',
  factory: () => ['zh-tw', 'en-us'],
});
